@if (universitySection() !== undefined) {
	<section class="container">
		<div class="divider">
			<h2 class="secondary-header !mb-0">
				{{ heading() }}
			</h2>
			<uc-university-section-navigation
				[navigationLabels]="labels"
				(selectKey)="onSelectKey($event)"
				[selectedKey]="selectedKey"
			/>
			@if (universitySection()[selectedKey]; as section) {
				<uc-university-section-card
					[name]="section.label!"
					[componentName]="section.label!"
					[description]="section.text"
					[image]="section.image"
					[product]="product()"
					[externalUrl]="externalUrl()"
					[uniId]="uniId()"
					[uniName]="uniName()"
					[ugSearchOrderPosition]="ugSearchOrderPosition()"
				/>
			}
		</div>
	</section>
}
